/**
 * Lädt externe Drittanbieter-Einbettungen (AMOSweb, Betterplace, Leaflet/OSM, hCaptcha)
 * erst nach Zustimmung statt automatisch beim Seitenaufruf.
 *
 * Zwei Wege zur Aktivierung, kombiniert:
 * 1. Automatisch, wenn im nativen Shopify-Cookie-Banner bereits "Preferences"
 *    zugestimmt wurde (Shopify.customerPrivacy) — keine zusätzliche Consent-UI
 *    für Besucher, die den Banner schon bestätigt haben.
 * 2. Manuell per Klick auf den Platzhalter-Button — für alle anderen (Banner
 *    abgelehnt oder noch nicht gesehen). Der manuelle Klick setzt NICHT
 *    rückwirkend die globale Preferences-Zustimmung, er schaltet nur genau
 *    dieses eine Embed für die aktuelle Seite frei.
 */
(function () {
  function buildIframe(gate) {
    var frame = gate.querySelector('.ku-consent-gate__frame');
    if (!frame) return;
    var iframe = document.createElement('iframe');
    iframe.src = gate.getAttribute('data-ku-src');
    iframe.title = gate.getAttribute('data-ku-title') || '';
    iframe.loading = 'lazy';
    frame.innerHTML = '';
    frame.appendChild(iframe);
  }

  function activate(gate) {
    if (!gate || gate.getAttribute('data-ku-active') === '1') return;
    gate.setAttribute('data-ku-active', '1');
    gate.classList.add('ku-consent-gate--active');

    if (gate.getAttribute('data-ku-kind') === 'iframe') {
      buildIframe(gate);
    } else {
      // andere Embed-Arten (z.B. Leaflet-Karte) initialisieren sich selbst,
      // hören auf dieses Event statt hier generischen Code zu bekommen
      gate.dispatchEvent(new CustomEvent('ku:consent-activated', { bubbles: true }));
    }
  }

  function activateAll() {
    document.querySelectorAll('[data-ku-gate]').forEach(activate);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ku-gate-activate]');
    if (!button) return;
    activate(button.closest('[data-ku-gate]'));
  });

  /* ------------------------------------------------------------------
   * hCaptcha (Spamschutz der Shopify-Formulare) — erst nach Einwilligung.
   * Der Wächter im <head> (layout/theme.liquid) hält hCaptcha zurück, indem
   * er Formulare mit data-nocaptcha markiert. Freigabe auf zwei Wegen, wie
   * bei den anderen Gates: (1) Einwilligung "Präferenzen" im Cookie-Banner
   * gilt für alle Formulare, (2) sonst eine Pflicht-Checkbox im Formular —
   * ohne sie lässt sich das Formular nicht absenden (Shopify erwartet beim
   * Absenden ein Captcha-Token).
   * Selektoren = dieselben Formulartypen, die Shopifys Captcha-Bootstrap
   * schützt (Kontakt, Kommentare, Kundenkonto).
   * ------------------------------------------------------------------ */
  var CAPTCHA_FORMS = [
    ['contact', 'contact'], ['contact', 'customer'], ['blogs', 'new_comment'], ['comments', 'new_comment'],
    ['account', 'customer_login'], ['account', 'recover_customer_password'], ['account', 'create_customer']
  ].map(function (p) {
    return "form[action*='/" + p[0] + "'] input[name='form_type'][value='" + p[1] + "']";
  }).join(',');
  var captchaCounter = 0;

  function captchaForms() {
    var seen = [];
    document.querySelectorAll(CAPTCHA_FORMS).forEach(function (input) {
      if (input.form && seen.indexOf(input.form) === -1) seen.push(input.form);
    });
    return seen;
  }

  function bindCaptcha(form) {
    form.setAttribute('data-ku-captcha-ok', '');
    form.removeAttribute('data-nocaptcha');
    try {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(form);
      }
    } catch (e) { /* Shopify bindet dann beim nächsten Fokus selbst */ }
  }

  function allowCaptchaEverywhere() {
    window.kuCaptcha = window.kuCaptcha || {};
    window.kuCaptcha.allowed = true;
    captchaForms().forEach(function (form) {
      form.removeAttribute('data-nocaptcha');
      var box = form.querySelector('.ku-captcha-consent');
      if (box) box.remove();
    });
  }

  function addCaptchaConsent(form) {
    if (form.querySelector('.ku-captcha-consent') || form.hasAttribute('data-ku-captcha-ok')) return;
    form.setAttribute('data-nocaptcha', 'true');
    var id = 'ku-captcha-consent-' + (++captchaCounter);
    var box = document.createElement('div');
    box.className = 'ku-captcha-consent';
    box.innerHTML =
      '<input type="checkbox" id="' + id + '" required>' +
      '<label for="' + id + '">Ich bin einverstanden, dass zum Schutz vor Spam beim Absenden der Dienst ' +
      'hCaptcha (Intuition Machines, Inc., USA) geladen wird. Dabei werden u. a. meine IP-Adresse und ' +
      'Geräteinformationen übertragen. <a href="/pages/datenschutz#hcaptcha">Mehr in der Datenschutzerklärung</a></label>';
    var submit = form.querySelector('[type="submit"]');
    var anchor = submit && submit.closest('.ku-form-actions, .contact__button, .form__buttons') || submit;
    if (anchor && anchor.parentNode && form.contains(anchor)) anchor.parentNode.insertBefore(box, anchor);
    else form.appendChild(box);
    box.querySelector('input').addEventListener('change', function (event) {
      if (event.target.checked) bindCaptcha(form);
    });
  }

  function setupCaptchaGate(preferencesAllowed) {
    if (preferencesAllowed) allowCaptchaEverywhere();
    else captchaForms().forEach(addCaptchaConsent);
  }

  /* ------------------------------------------------------------------
   * Footer-Link "Deine Datenschutz-Einstellungen" (/pages/data-sharing-opt-out)
   * öffnet die Einstellungen des Shopify-Cookie-Banners, damit Einwilligungen
   * von jeder Seite aus geändert/widerrufen werden können. Ohne Banner-API
   * (z. B. JS blockiert) bleibt es ein normaler Link auf die Seite.
   * ------------------------------------------------------------------ */
  var PRIVACY_LINK = 'a[href*="/pages/data-sharing-opt-out"]';

  document.addEventListener('click', function (event) {
    var link = event.target.closest(PRIVACY_LINK);
    if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  function markPrivacyLinks() {
    document.querySelectorAll(PRIVACY_LINK).forEach(function (link) {
      link.setAttribute('aria-haspopup', 'dialog');
    });
  }

  var consentChecked = false;
  function checkNativeConsentAll() {
    markPrivacyLinks();
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      setupCaptchaGate(false);
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        consentChecked = true;
        var consent = !error && window.Shopify.customerPrivacy
          ? window.Shopify.customerPrivacy.currentVisitorConsent() : null;
        var allowed = !!(consent && consent.preferences === 'yes');
        if (allowed) activateAll();
        setupCaptchaGate(allowed);
      }
    );
    // Falls die Consent-API nicht antwortet: Formulare trotzdem absendbar machen (mit Checkbox)
    setTimeout(function () { if (!consentChecked) setupCaptchaGate(false); }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkNativeConsentAll);
  } else {
    checkNativeConsentAll();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail && event.detail.preferencesAllowed === true) {
      activateAll();
      allowCaptchaEverywhere();
    }
  });

  window.kuConsentGate = { activate: activate, activateAll: activateAll };
})();
